module.exports = __webpack_public_path__ + "static/img/lius.44cdbdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lius.png
// module id = POgD
// module chunks = 0